import { useState, useEffect } from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

import { ICONS } from "@/assets";
import { ColumnMasterDealer } from "@/library/FormColumn";

import jsPDF from "jspdf";
import "jspdf-autotable";

import { API, URL } from "@/config/api";
import { ConfigProvider, Space, Table, Button, message, Skeleton } from "antd";

import ButtonExportPDF from "@/components/ButtonExportPDF";
import ButtonExportExcel from "@/components/ButtonExportExcel";

// import data from "./data";
import ModalComponent from "./ModalComponent";

import dayjs from "dayjs";

import { Link, useNavigate } from "react-router-dom";

// import column from "./ColumnForm";

import { createStyles } from "antd-style";
const useStyle = createStyles(({ css, token }) => {
  const { antCls } = token;
  return {
    customTable: css`
      ${antCls}-table {
        ${antCls}-table-container {
          ${antCls}-table-body,
          ${antCls}-table-content {
            scrollbar-width: thin;
            scrollbar-color: #eaeaea transparent;
            scrollbar-gutter: stable;
          }
        }
      }
    `,
  };
});

const MasterDealer = () => {
  const { styles } = useStyle();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [editData, setEditData] = useState(null);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [initialValues, setInitialValues] = useState({
    noAcc: "",
    nameAcc: "",
    keterangan: "",
    kode: "",
    kolom: "",
  });

  const hadleModalOpen = (type, record) => {
    if (type === "add") {
      setModalMode(type);
      setEditData(null);
      setIsModalOpen(true);
    } else {
      setModalMode(type);
      setEditData(record);
      setIsModalOpen(true);
    }
  };

  // const handleModalView = (record) => {
  //   setModalMode("view");
  //   setEditData(record);
  //   setIsModalOpen(true);
  // };

  // const handleModalAdd = () => {
  //   setModalMode("add");
  //   setEditData(null);
  //   setIsModalOpen(true);
  // };

  // const handleModalDelete = (record) => {
  //   setModalMode("delete");
  //   setEditData(record.id);
  //   setIsModalOpen(true);
  // };

  // const handleModalEdit = (record) => {
  //   setModalMode("edit");
  //   setEditData(record);
  //   setIsModalOpen(true);
  // };

  const handleEdit = async (data) => {
    try {
      const value = {
        nameAcc: data.nameAcc,
        noAcc: data.noAcc,
        keterangan: data.keterangan,
        kode: data.kode,
        kolom: data.kolom,
      };

      await API.put(URL.MASTER_ACC + "/update/" + data.id, value);
      await getData();
      message.success("Data successfully updated!");
    } catch (error) {
      console.error(error);
      message.error("Data unsuccessfully updated!");
    }
  };

  const handleDelete = async (id) => {
    try {
      await API.delete(URL.MASTER_ACC + "/" + id);
      await getData();
      message.success("Data successfully deleted!");
    } catch (error) {
      console.error(error);
      message.error("Data unsuccessfully deleted!");
    }
  };

  const getData = async () => {
    try {
      setLoading(true);
      const response = await API.get(URL.MASTER_DEALER + "/all");
      setData(response?.data?.data);
      setLoading(false);
    } catch (error) {
      message.error("Data failed to fetch!");
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();

    console.log(data);

    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);

  const actionColumn = {
    title: "Action",
    key: "action",
    align: "center",
    render: (_, record) => (
      <Space size="middle">
        {/* <button onClick={() => hadleModalOpen("view", record)}>
          <img src={ICONS.FaDetail} alt="View" />
        </button> */}

        <Link to={`/dealer/detail/${record.id}`}>
          <img src={ICONS.FaDetail} alt="View" />
        </Link>
      </Space>
    ),
  };

  const extendedColumn = [...ColumnMasterDealer.columns, actionColumn];

  const exportToExcel = async () => {
    const date = dayjs(); // Get current date
    const getMonthName = date.format("MMM");
    const formattedDate = date.format("MMM-YY");

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(getMonthName);

    // Tambahkan header utama
    worksheet.mergeCells("A1:E1");
    const header1 = worksheet.getCell("A1");
    header1.value = "MASTER ACCOUNT";
    header1.font = { bold: true, size: 24 };
    header1.alignment = { horizontal: "center", vertical: "middle" };
    header1.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFBDD7EE" }, // Light blue background
    };
    header1.border = {
      top: { style: "medium" },
      left: { style: "medium" },
      bottom: { style: "medium" },
      right: { style: "medium" },
    };

    worksheet.mergeCells("A2:E2");
    const header3 = worksheet.getCell("A2");
    header3.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "ffffff" }, // white background
    };

    // Tambahkan sub-header dengan tanggal
    worksheet.mergeCells("A3:E3");
    const header2 = worksheet.getCell("A3");
    header2.value = formattedDate;
    header2.font = { bold: true, size: 32 };
    header2.alignment = { horizontal: "center", vertical: "middle" };
    header2.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFBDD7EE" }, // Light blue background
    };
    header2.border = {
      top: { style: "medium" },
      left: { style: "medium" },
      bottom: { style: "medium" },
      right: { style: "medium" },
    };

    worksheet.getRow(4).height = 25;

    // Tambahkan header kolom
    const headers = ["NOMOR AKUN", "NAMA AKUN", "KODE", "KOLOM", "KETERANGAN"];
    headers.forEach((header, index) => {
      const cell = worksheet.getCell(4, index + 1); // Baris ke-3 untuk header kolom
      cell.value = header;
      cell.font = { bold: false, size: 12 };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFBDD7EE" }, // Light blue background
      };
      cell.border = {
        top: { style: "medium" },
        left: { style: "medium" },
        bottom: { style: "medium" },
        right: { style: "medium" },
      };
    });

    data.forEach((item, rowIndex) => {
      const row = worksheet.getRow(5 + rowIndex); // Data dimulai dari baris ke-4
      row.getCell(1).value = item.noAcc;
      row.getCell(2).value = item.nameAcc;
      row.getCell(3).value = item.kode;
      row.getCell(4).value = item.kolom;
      row.getCell(5).value = item.keterangan;

      row.getCell(1).alignment = { horizontal: "center", vertical: "middle" };
      row.getCell(3).alignment = { horizontal: "center", vertical: "middle" };
      row.getCell(4).alignment = { horizontal: "center", vertical: "middle" };

      const borderStyle = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };

      // Loop through cells 1 to 5 and apply the border style
      for (let i = 1; i <= headers.length; i++) {
        row.getCell(i).border = borderStyle;
      }
    });

    // Atur lebar kolom
    worksheet.columns = [
      { width: 20 },
      { width: 40 },
      { width: 20 },
      { width: 20 },
      { width: 60 },
    ];

    // Generate file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `Laporan Master Account.xlsx`);
  };

  return (
    <div>
      <h1 className="text-4xl font-semibold mb-8">Master Showroom / Dealer</h1>

      {/* <ModalComponent
        isVisible={isModalOpen}
        onClose={() => (setIsModalOpen(false), setModalMode(null))}
        mode={modalMode}
        initData={editData}
        handleAdd={handleAdd}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        column={ColumnMasterDealer.dataForm}
        initialValues={initialValues}
      /> */}

      <div className="flex justify-between">
        {/* <Button
          type="primary"
          size="large"
          onClick={() => hadleModalOpen("add", null)}
          className=" bg-primary text-white py-2 px-4 rounded-md mb-4"
        >
          Tambah Data
        </Button> */}

        <div className="flex gap-4">
          {/* <ButtonExportPDF onClick={exportPDF} /> */}
          <ButtonExportExcel onClick={exportToExcel} />
        </div>
      </div>

      {loading ? (
        <Skeleton active />
      ) : (
        <ConfigProvider
          theme={{
            components: {
              Table: {
                colorPrimary: "#0164A2",
                headerColor: "#fff",
                headerBg: "#0164A2",
                headerBorderRadius: 6,
                algorithm: true,
                // borderColor: "#000",
              },
              Pagination: {
                colorPrimary: "#0164A2",
                colorPrimaryHover: "#0164A2",
                colorPrimaryBorder: "#0164A2",
                algorithm: true,
              },
            },
          }}
        >
          <Table columns={extendedColumn} dataSource={data} size="middle" />
        </ConfigProvider>
      )}
    </div>
  );
};

export default MasterDealer;
